<ui-modal [(open)]="open" [heading]="modalHeading()" (closed)="onModalClosed()">
  <div class="picker">
    <!-- Legacy's tab strip, as the content context offers it: Upload and My
         Media always, the three photo libraries for an image post, Giphy for a
         video post (media-modal.component.html:5-167). -->
    <div ui-tabs type="line" size="sm" [selected]="tab()" (selectedChange)="selectTab($event)">
      @for (entry of tabs(); track entry.id) {
        <button ui-tab [value]="entry.id">{{ entry.label }}</button>
      }
    </div>

    @if (onUpload()) {
      <!-- Drag-and-drop plus a real <input type="file">: the label is the visible
           control and the input behind it keeps the platform's keyboard and
           screen-reader behaviour, so no click handler on a <div> is needed. -->
      <div
        class="picker__drop"
        [class.picker__drop--over]="dragging()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
      >
        <ui-icon class="picker__drop-icon" name="upload-cloud" [strokeWidth]="1.5" />
        <p class="picker__drop-lead">Drag and drop, or</p>
        <label class="picker__browse" [class.picker__browse--full]="remaining() === 0">
          <input
            class="picker__file"
            type="file"
            [accept]="accept()"
            [multiple]="multiple()"
            [disabled]="remaining() === 0"
            (change)="onSelect($event)"
          />
          <span>Browse files</span>
        </label>
        <p class="picker__hint">{{ hint() }}</p>
      </div>
    } @else {
      <div class="picker__library">
        @if (searchable()) {
          <ui-search-input [tailIcon]="undefined">
            <input
              uiInput
              type="search"
              [placeholder]="searchPlaceholder()"
              [attr.aria-label]="searchPlaceholder()"
              [value]="searchDraft()"
              (input)="onSearchInput($any($event.target).value)"
              (keydown.enter)="onSearchEnter()"
            />
          </ui-search-input>
        }

        @if (credit(); as line) {
          <!-- media-library.component.html:34-36. The providers ask for the
               credit on screen; nothing about it is stored on the media element,
               because legacy stores none either. -->
          <p class="picker__credit">{{ line }}</p>
        }

        @if (loadError(); as message) {
          <ui-feedback-banner type="error" [description]="message" />
          <button ui-button type="button" variant="secondary" size="sm" (click)="retry()">
            Try again
          </button>
        } @else {
          @if (items().length) {
            <ul class="picker__grid">
              @for (item of items(); track item.key) {
                <li>
                  <button
                    class="picker__tile"
                    type="button"
                    [class.picker__tile--on]="isChosen(item)"
                    [attr.aria-pressed]="isChosen(item)"
                    [disabled]="isAttached(item)"
                    [title]="item.name"
                    (click)="toggle(item)"
                  >
                    <img class="picker__tile-image" [src]="item.thumbUrl" alt="" loading="lazy" />
                    <span class="sr-only">{{ item.name }}</span>
                    @if (isAttached(item)) {
                      <span class="picker__tile-flag">Added</span>
                    } @else if (isChosen(item)) {
                      <span class="picker__tile-flag" aria-hidden="true">
                        <ui-icon name="check" [strokeWidth]="2" />
                      </span>
                    }
                  </button>
                </li>
              }
            </ul>
          }

          @if (loading()) {
            <p class="picker__note" role="status">Loading…</p>
          } @else if (!items().length) {
            <p class="picker__note">{{ emptyMessage() }}</p>
          } @else if (hasMore()) {
            <button ui-button type="button" variant="secondary" size="sm" (click)="loadMore()">
              Load more
            </button>
          }
        }
      </div>
    }

    @if (rejected(); as message) {
      <ui-feedback-banner type="error" [description]="message" />
    }

    <!-- One strip for everything chosen, so a pick made on My Media is still
         visible after switching to Pexels — legacy keeps one `selectedMedia`
         array across its tabs for the same reason. -->
    @if (selection().length) {
      <ul class="picker__list">
        @for (entry of selection(); track entry.key) {
          <li class="picker__item">
            @if (entry.thumbUrl; as preview) {
              <img class="picker__thumb" [src]="preview" alt="" />
            } @else {
              <span class="picker__thumb picker__thumb--glyph" aria-hidden="true">
                <ui-icon [name]="entry.glyph" />
              </span>
            }
            <span class="picker__name">{{ entry.name }}</span>
            <button
              class="picker__remove"
              type="button"
              [attr.aria-label]="'Remove ' + entry.name"
              (click)="remove(entry)"
            >
              <ui-icon name="x" [strokeWidth]="1.5" />
            </button>
          </li>
        }
      </ul>
    }
  </div>

  <div uiModalActions>
    <button ui-button type="button" [disabled]="!canAdd()" (click)="confirm()">
      {{ addLabel() }}
    </button>
    <button ui-button type="button" variant="secondary" (click)="cancel()">Cancel</button>
  </div>
</ui-modal>
